<template>
  <div
    class="item mr-2 mb-3"
    :class="{ 'item--blur': blur }"
    v-on="$listeners"
    role="button"
  >
    <span class="item__text">
      <slot v-if="!blur" />
      <span v-else class="item__text__placeholder">{{ placeholder }}</span>
    </span>

    <span v-if="$slots.quantity" class="item__quantity">
      <slot name="quantity" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    blur: { type: Boolean, default: false },
  },

  computed: {
    placeholder() {
      return (Math.random() + 1).toString(36).substring(Math.floor(Math.random() * (5)) + 2)
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .item {
    $p: &;

    display: inline-flex;
    border-radius: 36px;
    padding: 8px 16px;
    cursor: pointer;
    background: $purple20;

    &__text {
      font-size: 0.89rem;
      user-select: none;
    }

    &__quantity {
      font-size: 14px;
      margin-left: 8px;
      padding-left: 8px;
      border-left: 2px solid #CBCBCB;
      font-weight: 500;
    }

    &__text,
    &__quantity {
      padding-top: 5px;
      padding-bottom: 5px;
      background: transparent;
    }

    &--blur &__text {
      filter: blur(3px);
    }
    
    &.active:not(&--blur) {
      background: $purple400;
      
      #{$p}__text,
      #{$p}__quantity {
        color: #fff;
      }

      #{$p}__quantity {
        border-color: rgba(#fff, .25);
      }
    }
  }
</style>